import { GenericValue } from 'hisng';
import { Component } from '@angular/core';
import { WithDatasourceComponent } from './with-datasource.component';

@Component( {
    selector: 'erp-pbw-geschlecht',
    templateUrl: './with-datasource.component.html'
} )
export class GenderFormComponent extends WithDatasourceComponent<GenericValue>   {

    constructor() {
        super(
            {
                datasourceName: 'api/v1/rm/erp/person/value/gender',
                fieldDisplayName: 'text',
                i18nIdentifier: 'rm.erp.jobapplication.JobApplication.gender',
            } );
    }

    set value( t: GenericValue | undefined ) {
        if ( this.jobapplication != null ) {
            this.jobapplication.gender = t;
        }
    }

    get value(): GenericValue | undefined {
        return this.jobapplication?.gender;
    }

    getFieldValue( t?: GenericValue ): string | undefined {
        return t?.text;
    }
}
